
import { method } from 'lodash';
import Vue from 'vue'
import { mapGetters } from 'vuex'

const VesselMonitoringTypeConst = {
  Load: 'Load',
  Discharge: 'Discharge'
}

export default Vue.extend({

  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      abc: ''
    }
  },
  computed: {
    // Explicitly access store getters to satisfy TypeScript typing
    getVesselMonitoringType() {
      return (this.$store && (this.$store.getters as any).getVesselMonitoringType) as string;
    },
    getVesselMonitoringContainerDetail() {
      return (this.$store && (this.$store.getters as any).getVesselMonitoringContainerDetail) as any;
    },
    VesselMonitoringType() {
      return VesselMonitoringTypeConst
    },
    getLoadedWrongPositionNotMatchedFieldsItems() {
      if (!this.getVesselMonitoringContainerDetail) return [];
      const raw = this.getVesselMonitoringContainerDetail.loadedWrongPositionNotMatchedFields;
      if (!raw) return [];
      return raw?.split(',').map(item => item.trim()).filter(item => item !== '');
    },
  },
    methods: {
    hasWrongPositionField(fieldName: string) {
      return this.getLoadedWrongPositionNotMatchedFieldsItems?.includes(fieldName);
    },
  }
})
